import Accomplishments from "./components/Accomplishments";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import NavBar from "./components/NavBar";
import Projects from "./components/Projects";
import Technologies from "./components/Technologies";
import Timeline from "./components/Timeline";


function App() {
  return (
    <div class = "bg-darkBlue text-white">
      <NavBar />
      <Hero />
      <Projects />
      <Technologies />
      <Timeline />
      {/* <Accomplishments /> */}
      <Footer />
    </div>
  );
}

export default App;
